// src/app/gorunumFiltreUrl.ts
//
// ─── GÖRÜNÜM FİLTRESİ → ADRES ÇUBUĞU (saf karar katmanı) ─────────────────────
//
// ── ÖLÇÜLEN İKİ BOŞLUK ──────────────────────────────────────────────────────
// 1. `Bildirimler.tsx:159` — `useState<"all"|"unread">("all")`. `/notifications`
//    yenilenince DAİMA "Tümü"ye dönüyordu; "Okunmamış" görünümü paylaşılamıyordu.
// 2. `LabubuGridMobile/Desktop` — `useState<RarityFilter>("all")`. MyCards
//    koleksiyon filtresi (Tümü/Rare/Legendary) aynı şekilde adressizdi.
// İkisi de kanonun *"her görünüm kendi URL'sini üretir, cold-load çalışır"*
// kuralının dışındaydı.
//
// ══════════════════════════════════════════════════════════════════════════
// ── YOL mu SORGU mu — ÖLÇÜLEREK SEÇİLDİ (gerekçe burada yaşar) ─────────────
// ══════════════════════════════════════════════════════════════════════════
//
// Depodaki emsal SAYIMI (çoğunluk YOL):
//   YOL  : `/{u}/saved` · `/{u}/tagged` · `/{u}/cards` (profilSekmeUrl +
//          profileUrlSync) · `/clips/{following|neighborhood|saved}` ·
//          `/clips/tags/{tag}` · `/clips/trending/{section}` ·
//          `/explore/tags/{tag}`                                    → 7
//   SORGU: `/clips/search?q={q}` (discoveryUrl.syncSearchQueryUrl)   → 1
//          (`?go=` · `?c=` · `?p=` · `?discover=1` SAYILMADI: bunlar
//          Hosting rewrite'ının insan-yolu sarmalları, görünüm alt-durumu
//          DEĞİL — sayıma katmak paydayı şişirirdi.)
//
// Yani çoğunluk YOL. Ama iki işte de YOL **ölçülerek** elendi:
//
// 🔴 MyCards filtresi — YOL FİİLEN İMKÂNSIZ (çakışma ölçüldü):
//    `/{u}/cards/{X}` şeması ZATEN DOLU — `kartDetayUrl.KART_DETAY_YOLU_DESENI`
//    onu KART DETAY PERMALİNKİ olarak okuyor. Ölçüm:
//        "/ali/cards/rare"      → {seg1:"ali", kod:"rare"}
//        "/ali/cards/legendary" → {seg1:"ali", kod:"legendary"}
//        "/ali/cards/S1-007"    → {seg1:"ali", kod:"S1-007"}
//    Üçü de AYNI dala düşüyor. Filtreyi oraya yazmak, kart kodu ad-uzayının
//    içine ikinci bir rezerve-kelime listesi açmak demekti ("rare" ve
//    "legendary" artık kart kodu OLAMAZ) — kanonun kapatmaya çalıştığı
//    "çürüyen liste" sınıfının yenisi.
//
// 🟠 Bildirim filtresi — YOL MÜMKÜN AMA DÖRT KOPYAYI SENKRON İSTİYOR:
//    `/^\/notifications\/?$/` deseni kod tabanında DÖRT yerde yaşıyor
//    (`appRouting` matcher + `appRouting` popstate kapısı + `appModals`
//    kapanış temizliği + `App.handleNavChange` push kapısı). Ölçüm:
//        "/notifications/unread" → dördünde de FALSE
//    Dördü birden güncellenmezse en az biri SESSİZ regresyon üretir; en
//    kötüsü `appModals`: URL temizlenmez → kullanıcı X ile kapatır,
//    yeniler ve modal geri gelir (o dosyanın kendi yorumu bu kusuru
//    zaten tarif ediyor).
//
// ✅ SORGU (`?f=…`) ise `pathname`i DEĞİŞTİRMEZ → yukarıdaki dört kapı ve
//    `profileUrlSync.useProfileSubUrlSync`in `pathname === target` erken
//    dönüşü AYNEN çalışır. Yani seçim "estetik" değil: **davranış deltası
//    sıfır olan tek şema.** Emsalsiz de değil — `/clips/search?q=` aynı şeyi
//    yapıyor: yol GÖRÜNÜMÜ, sorgu o görünümün İÇİNDEKİ daraltmayı taşıyor.
//    Bu iki iş de tam olarak "görünümün içindeki daraltma"dır.
//
// ── PUSH DEĞİL REPLACE ──────────────────────────────────────────────────────
// `discoveryUrl.writeTabUrl` kuralı birebir: **"modlar replace, katmanlar
// push"**. Filtre bir MOD'dur (aynı ekranın daraltılmış hâli) → `replaceState`.
// Aksi halde Tümü↔Okunmamış arasında gidip gelmek history'yi şişirir ve geri
// tuşu paneli kapatmak yerine filtreler arasında dolaşırdı.
//
// ── VARSAYILAN = PARAMETRE YOK ──────────────────────────────────────────────
// `all` seçiliyken `?f=all` YAZILMAZ, parametre SİLİNİR. Gerekçe ölçülebilir:
// paylaşılan URL'lerin çoğunluğu varsayılan hâldedir; `?f=all` taşımak her
// paylaşımı gereksiz kirletir ve iki farklı dize (`/notifications` vs
// `/notifications?f=all`) AYNI ekranı gösterirdi.
//
// ── SAF ────────────────────────────────────────────────────────────────────
// `window`a DOKUNMAZ (kanca `useGorunumFiltreUrl` bağlar) → kapı gerçek
// fonksiyonu koşturabilir, "kaynakta şu dizge var mı" ölçümüne düşülmez.

// Tip-yalnız: derlemede silinir, çalışma-zamanı bağı YOK. İkinci bir
// "hangi nadirlik filtreleri var" listesi yazmamak için ÜRETİCİDEN alınır.
import type { RarityFilter } from "../components/Labubu/collectionSort";
// `/{u}/cards` şemasının TEK SAHİBİ — buraya ikinci bir regex kopyalanmaz.
import { kartIzgaraYolundaMi } from "./kartDetayUrl";

/** Bir görünümün sorgu-parametreli filtre sözleşmesi. */
export type FiltreSozlesmesi<T extends string> = {
  /** Sorgu anahtarı (`?f=`). */
  anahtar: string;
  /** Kabul edilen değerler — dışındaki her şey `varsayilan`a düşer. */
  izinli: readonly T[];
  /** Varsayılan değer; seçiliyken parametre URL'den SİLİNİR. */
  varsayilan: T;
  /** Bu filtre hangi yolda anlamlı? Başka yolda ne okunur ne yazılır. */
  yolGecerliMi: (yol: string) => boolean;
};

export type FiltreKarari =
  | { tur: "yok"; hedef: null }
  | { tur: "replace"; hedef: string };

// ─── BİLDİRİMLER ────────────────────────────────────────────────────────────
//
// ⚠️ TEK KAYNAK: bu desen eskiden DÖRT yerde ayrı ayrı yazılıydı
// (`appRouting` ×2, `appModals`, `App.tsx`). Dördü de birebir aynıydı ama
// hiçbir mekanizma onları birlikte tutmuyordu — kanonun "çürüyen liste"
// sınıfının uyuyan bir üyesi. Artık dördü de bu yüklemi çağırıyor.
export const BILDIRIM_YOLU_DESENI = /^\/notifications\/?$/;

/** Yol bildirim panelinin kendi yolu mu? (`/notifications`, trailing slash serbest) */
export function bildirimYolundaMi(yol?: string | null): boolean {
  return BILDIRIM_YOLU_DESENI.test(yol || "");
}

/** `Bildirimler.tsx` filtre sekmesi — `filterTab` state'iyle BİREBİR küme. */
export type BildirimFiltresi = "all" | "unread";

export const BILDIRIM_FILTRESI: FiltreSozlesmesi<BildirimFiltresi> = {
  anahtar: "f",
  izinli: ["all", "unread"],
  varsayilan: "all",
  yolGecerliMi: bildirimYolundaMi,
};

// ─── MYCARDS KOLEKSİYON IZGARASI ────────────────────────────────────────────
//
// Değer kümesi `collectionSort.RarityFilter`ten TÜRETİLİR (tip) ama listenin
// kendisi burada yazılı olmak ZORUNDA (çalışma zamanında bir tip okunamaz).
// Sapmayı derleyici yakalar: `izinli` bir `RarityFilter[]`tir, yeni bir
// nadirlik eklenirse buraya eklemek DERLEME hatası vermez ama eksik değer
// `varsayilan`a düşer ve testi kırılır (`gorunumFiltreUrl.test.ts` kümeyi
// üreticiyle karşılaştırır).
export const KART_FILTRESI: FiltreSozlesmesi<RarityFilter> = {
  anahtar: "f",
  izinli: ["all", "rare", "legendary"],
  varsayilan: "all",
  yolGecerliMi: kartIzgaraYolundaMi,
};

// ─── SAF KARARLAR ───────────────────────────────────────────────────────────

/** Sorgu dizesinden anahtarın HAM değeri (yol kapısı UYGULANMADAN). */
function hamDeger(arama: string | null | undefined, anahtar: string): string | null {
  try {
    return new URLSearchParams(arama || "").get(anahtar);
  } catch {
    // Bozuk sorgu dizesi → "değer yok" (varsayılana düşer). Sessiz DEĞİL:
    // çağıran zaten varsayılanı görür, ekran doğru çalışır.
    return null;
  }
}

/** Değeri sözleşmeye göre daralt; tanınmayan/eksik → varsayılan. */
function daralt<T extends string>(s: FiltreSozlesmesi<T>, ham: unknown): T {
  const d = ham == null ? "" : String(ham);
  return (s.izinli as readonly string[]).includes(d) ? (d as T) : s.varsayilan;
}

/**
 * Cold-load / mount: URL hangi filtreyi istiyor?
 *
 * Yol sözleşmeye uymuyorsa (ör. kart ızgarası MODAL profilde, adres `/c/{id}`)
 * **varsayılan** döner — başka bir görünümün `?f=` parametresi buraya sızmaz.
 */
export function filtreyiYoldanOku<T extends string>(
  s: FiltreSozlesmesi<T>,
  yol?: string | null,
  arama?: string | null,
): T {
  if (!s.yolGecerliMi(yol || "")) return s.varsayilan;
  return daralt(s, hamDeger(arama, s.anahtar));
}

/**
 * Aktif filtre değişti → adres çubuğuna ne yazılmalı?
 *
 * `deger: string` BİLEREK (`profilSekmeUrlKarari` ile aynı gerekçe): üretici
 * `useState<T>` olsa bile bayat/serileştirilmiş bir değer gelebilir.
 * Tanınmayan değer varsayılan sayılır → parametre silinir.
 */
export function filtreUrlKarari<T extends string>(
  s: FiltreSozlesmesi<T>,
  deger: string,
  yol?: string | null,
  arama?: string | null,
): FiltreKarari {
  const y = yol || "";
  // Bu filtrenin yolu değiliz → adres çubuğuna DOKUNMA.
  if (!s.yolGecerliMi(y)) return { tur: "yok", hedef: null };

  const yeni = daralt(s, deger);
  const mevcut = daralt(s, hamDeger(arama, s.anahtar));
  // ⚠️ KARŞILAŞTIRMA DARALTILMIŞ DEĞERLER ÜZERİNDEN: ham dize karşılaştırmak
  // `?f=rare` ile `?f=RARE`i farklı sayıp her render'da replaceState atardı.
  if (yeni === mevcut) {
    // Tek istisna: varsayılan seçiliyken URL'de HÂLÂ bir parametre duruyorsa
    // (ör. `?f=bozuk`) onu temizlemek gerekir — aksi halde paylaşılan adres
    // ekranda olmayan bir filtre iddia ederdi.
    const ham = hamDeger(arama, s.anahtar);
    if (!(yeni === s.varsayilan && ham !== null)) return { tur: "yok", hedef: null };
  }

  let sp: URLSearchParams;
  try {
    sp = new URLSearchParams(arama || "");
  } catch {
    sp = new URLSearchParams();
  }
  // Varsayılan → parametreyi SİL (bkz. dosya başı gerekçesi).
  if (yeni === s.varsayilan) sp.delete(s.anahtar);
  else sp.set(s.anahtar, yeni);
  const qs = sp.toString();
  return { tur: "replace", hedef: qs ? `${y}?${qs}` : y };
}

/**
 * Mount koşusunda filtre URL'si YAZILMAZ — `profilSekmeYazimiAtla`nın
 * gerekçesi birebir: cold-load URL'sini (`/notifications?f=unread`) ezmemek
 * için. State zaten o URL'den TOHUMLANIYOR; mount'ta yazmak, düzeltmeyi
 * düzeltmenin kendisiyle ezmek olurdu.
 */
export function filtreYazimiAtla(opts: { ilkCalisma: boolean }): boolean {
  return !!opts.ilkCalisma;
}

/**
 * popstate → hangi filtreye geçilmeli?
 *   · sözleşmenin yolu değil → null ("filtreye DOKUNMA")
 *   · zaten o filtredeyiz    → null (gereksiz setState yok)
 *   · farklı filtre          → uygulanacak değer
 */
export function filtrePopHedefi<T extends string>(
  s: FiltreSozlesmesi<T>,
  yol: string | null | undefined,
  arama: string | null | undefined,
  mevcutDeger: string,
): T | null {
  if (!s.yolGecerliMi(yol || "")) return null;
  const hedef = daralt(s, hamDeger(arama, s.anahtar));
  if (hedef === daralt(s, mevcutDeger)) return null;
  return hedef;
}
